// extracted by mini-css-extract-plugin
export default {"index":"events_index__F27u2","body":"events_body__xP4tC","toolbar":"events_toolbar__GGajY"};